export default __webpack_public_path__ + "static/media/Jakub Petrykowski.b4debd43.jpg";